<script setup lang="ts">
import { TagProps } from "./Tag.props"

defineProps<TagProps>()
</script>

<template>
  <AppLink v-if="url && text" tabindex="0" :to="url">
    <span class="mouse rounded bg-tiffany-30 px-2 py-1">
      {{ text }}
    </span>
  </AppLink>
  <span v-else-if="text" class="mouse rounded bg-tiffany-30 px-2 py-1">
    {{ text }}
  </span>
</template>
